import {
  INewGuestCompany,
  INewGuestPhysicalPerson,
} from 'modules/accommodations/features/reservations/models';
import API from 'services/api';

export const insertGuest = (payload: INewGuestCompany | INewGuestPhysicalPerson) => {
  return API.post('api/accommodation/guests', payload).then(res => res?.data);
};
